import { uniqueId } from 'lodash';

import { TransactionStatus } from 'dashboard/models/transaction-status';
import {
  TransactionType,
  TransactionTypeAttributes,
  TransactionTypeStatus,
} from 'dashboard/models/transaction-type';
import { FieldSchemaType } from 'lib/fields';
import { ApiModel } from 'lib/interfaces/api';

export const generateTransactionTypeId = () => uniqueId('txntp_');
export const generateTransactionStatusId = () => uniqueId('txnstp_');

export function createPreviewTransactionType(
  attributes?: Partial<TransactionTypeAttributes>,
  id?: string,
  defaultStatusId?: string,
  statuses?: TransactionStatus[],
): TransactionType {
  return {
    id: id || generateTransactionTypeId(),
    type: ApiModel.TransactionType,
    attributes: {
      'created-at': '2019-10-19T06:31:58.000Z',
      'updated-at': '2019-10-19T09:31:58.000Z',
      name: 'txn type',
      status: TransactionTypeStatus.Active,
      'field-schemas': [
        {
          key: 'alert_name',
          label: '',
          type: FieldSchemaType.String,
          config: {},
        },
        {
          key: 'total',
          label: '',
          type: FieldSchemaType.Integer,
          config: {},
        },
        {
          key: 'is_deposit',
          label: '',
          type: FieldSchemaType.Boolean,
          config: {},
        },
        {
          key: 'flagged',
          label: '',
          type: FieldSchemaType.Boolean,
          config: {},
        },
      ],
      'relation-schemas': [],
      'environment-id': '1',
      ...attributes,
    },
    relationships: {
      'default-status': {
        data: {
          type: ApiModel.TransactionStatus,
          id: defaultStatusId || generateTransactionStatusId(),
        },
      },
      statuses: {
        data: (statuses || []).map((status) => {
          return { type: ApiModel.TransactionStatus, id: status.id };
        }),
      },
    },
  };
}
